<div class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4">
    <div class="flex items-start justify-between">
        <div class="text-xl font-medium tracking-tight leading-6 truncate">N. application per batch e per regione (il
            conteggio non
            contempla le Application dall'Estero)
        </div>

    </div>
    <div class="flex w-full items-center flex-auto mt-6 h-auto">
        <app-dashboard-chart
                class="custom-legend-chart h-120 md:h-160"
                [chartData]="chartAppBatchForRegion"></app-dashboard-chart>
    </div>
</div>

